/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import Component from 'can/component/component';
import Map from 'scripts/models/base/map';
import appContext from 'scripts/app-context';
import template from './drawer-qualifying.stache';

Component.extend({
    tag: 'qualifying-leaderboard-drawer',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            round: {
                type: 'number',
                value: null,
            },
            data: {
                Type: Map,
                Value: Map,
            },
            startHole: {
                get() {
                    const round = this.attr('round');
                    let start = 1;
                    if (round) {
                        start = this.attr(
                            `data.player.roundsInfo.${round -
                                1}.scorecard.holeResults.0.hole.identifier`,
                        );
                    }
                    return start;
                },
            },
        },
        updateData(data) {
            this.attr('data', data);
        },
    },
    events: {
        '.js-drawer-close click'($el) {
            $el.closest('.s-board-row').hide();
        },
    },
});
